"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectDeviceBest = void 0;
const constants_1 = require("../constants");
const detectDevice_1 = require("./detectDevice");
function detectDeviceBest() {
    const device = (0, detectDevice_1.detectDevice)();
    if (device === constants_1.Device.MOBILE || device === constants_1.Device.DESKTOP) {
        return constants_1.InteractionModes.ON_PAGE;
    }
    else if (device === constants_1.Device.WEBVIEW) {
        return constants_1.InteractionModes.REDIRECT;
    }
    return constants_1.InteractionModes.REDIRECT;
}
exports.detectDeviceBest = detectDeviceBest;
